import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Icon } from '@tf/ui';
import type React from 'react';
import { useNavigate } from 'react-router-dom';

import { SimplePage } from '@/components/shared';

import { usePageTitle } from '../usePageTitle';

export const NotFoundRoute: React.FC = () => {
	const { _ } = useLingui();
	const navigate = useNavigate();

	usePageTitle(_(msg({ id: 'notFoundPage.title', message: 'Page not found' })));

	return (
		<SimplePage
			title={_(msg({ id: 'notFoundPage.title', message: 'Page not found' }))}
			description={_(
				msg({
					id: 'notFoundPage.message',
					message: 'Sorry, the page you were looking for was not found',
				}),
			)}
			action={{
				icon: <Icon.IconHome />,
				label: _(msg({ id: 'notFoundPage.action', message: 'Back to home page' })),
				onClick: () => navigate('/'),
			}}
		/>
	);
};
